import { render, staticRenderFns } from "./ProjectInput.vue?vue&type=template&id=d8a71732&scoped=true&"
import script from "./ProjectInput.vue?vue&type=script&lang=js&"
export * from "./ProjectInput.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInput.vue?vue&type=style&index=0&id=d8a71732&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a71732",
  null
  
)

export default component.exports